// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"40bc109c","453":"0bb5fe25","732":"e89a1c6a","977":"3a3d4709"}[chunkId] + ".chunk.js";
};